module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"label":"查看各商品规格评价","description":"*显示的评论数量可能会根据统计时间与实际数量有所差异。"}}')
  delete Component.options._Ctor
}
